import '../scss/app.scss';

import * as bootstrap from 'bootstrap';
// import Tooltip from 'bootstrap';

// inline {% js %} blocks are classic scripts with no module access,
// so bootstrap's JS components (Toast, Modal, ...) need a global
window.bootstrap = bootstrap;

import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

import Choices from 'choices.js';
import 'choices.js/src/styles/choices';

document.documentElement.classList.replace('no-js', 'js');
setTimeout(() => {
    document.documentElement.classList.add('transitions');
}, 250);

// // Activates tooltips
window.initTooltip = function (){
  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl);
  });
}

document.addEventListener('DOMContentLoaded', function () {

  initTooltip();

});


document.addEventListener('freeform-ready', (event) => {
  // scrolling offset in pixels from the top of the form.
  // defaults to 0
  event.options.scrollOffset = -130;
});

document.addEventListener('DOMContentLoaded', function () {

    // prevent my dropdown from closing when clicking inside it
    document.querySelectorAll('.dropdown-menu .nav-item .nav-link, .dropdown-menu .btn-primary').forEach((el) => {
      el.addEventListener('click', (e) => e.stopPropagation());
    });

    document.querySelectorAll('.js-hamburger').forEach((el) => {
      el.addEventListener('click', () => el.classList.toggle('is-active'));
    });

    document.querySelectorAll('iframe').forEach((el) => {
      const figure = el.closest('figure');
      if (figure) figure.classList.add('responsive-iframe');
    });

    document.querySelectorAll('.bb table').forEach((table) => {
      const wrapper = document.createElement('div');
      wrapper.className = 'table-responsive';
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });


    const swiper = new Swiper('.swiper', {
        modules: [Navigation, Pagination, Scrollbar],
        // Optional parameters
        loop: true,
        slidesPerView: 1,
        spaceBetween: 40,
        breakpoints: {
            // when window width is >= 320px
            768: {
              slidesPerView: 2,
              spaceBetween: 20
            }
        },

        // If we need pagination
        pagination: {
          el: '.swiper-pagination',
        },

        // Navigation arrows
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },

        // And if we need scrollbar
        scrollbar: {
          el: '.swiper-scrollbar',
        },
      });

  document.querySelectorAll('select.js-choices').forEach((el) => {
    const choices = new Choices(el, {
      searchEnabled: true,
      shouldSort: false,
      placeholder: true,
      placeholderValue: 'Kies een optie…',
      searchPlaceholderValue: 'Zoeken…',
      itemSelectText: 'Klik om te selecteren',
      noResultsText: 'Geen resultaten gevonden',
      noChoicesText: 'Geen opties beschikbaar',
      loadingText: 'Bezig met laden…',
    });

    // container van deze Choices instance
    const container = el.closest('.choices');
    if (!container) return;

    // helper om aria-labels te vertalen
    const translateAria = (root) => {
      root.querySelectorAll('[aria-label="Press to select"]').forEach((node) => {
        node.setAttribute('aria-label', 'Klik om te selecteren');
      });
    };

    // 1) direct na init (voor het geval er al items zijn)
    translateAria(container);

    // 2) elke keer als de dropdown wordt getoond
    choices.passedElement.element.addEventListener('showDropdown', () => {
      translateAria(container);
    });

    // 3) mutation observer: nieuwe/gewijzigde nodes meteen vertalen
    const mo = new MutationObserver(() => translateAria(container));
    mo.observe(container, { subtree: true, childList: true, attributes: true });
  });

});

